import React from 'react';
import { PropTypes } from 'prop-types';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import { CarouselCursor as ArrowIcon } from '../../Cursors';

import { ButtonTypes } from './consts';

const CarouselNavigationButtons = ({ styles, moveToSlideId, activeIndex, theme, type }) => (
    <div className={styles.navigationContainer}>
        <button
            data-event-id="carousel-arrow-bw"
            className={getPlausibleClassName(styles.navigationButtonLeft, AnalyticsEvent.CAROUSEL_BW_ARROW_CLICK, {
                // TODO: add missing properties
            })}
            onClick={() => moveToSlideId(activeIndex - 1)}
            type="button"
        >
            <ArrowIcon
                fill={type === ButtonTypes.LIGHT ? theme.colors.white : theme.colors.black}
                stroke={type === ButtonTypes.LIGHT ? theme.colors.blue : theme.colors.cyan}
            />
        </button>
        <button
            data-event-id="carousel-arrow-fw"
            className={getPlausibleClassName(styles.navigationButton, AnalyticsEvent.CAROUSEL_FW_ARROW_CLICK, {
                // TODO: add missing properties
            })}
            onClick={() => moveToSlideId(activeIndex + 1)}
            type="button"
        >
            <ArrowIcon
                fill={type === ButtonTypes.LIGHT ? theme.colors.white : theme.colors.black}
                stroke={type === ButtonTypes.LIGHT ? theme.colors.blue : theme.colors.cyan}
            />
        </button>
    </div>
);

CarouselNavigationButtons.propTypes = {
    styles: PropTypes.shape().isRequired,
    type: PropTypes.oneOf(Object.values(ButtonTypes)),
    moveToSlideId: PropTypes.func.isRequired,
    activeIndex: PropTypes.number.isRequired,
    theme: PropTypes.shape().isRequired,
};

CarouselNavigationButtons.defaultProps = {
    type: ButtonTypes.DARK,
};

export default CarouselNavigationButtons;
